import { VegaCard, VegaDivider, VegaFlex, VegaFont } from '@globalpayments/vega-react';

interface Props {
  message: MessageEvent;
  delay: number;
}

const ReceivedMessage: React.FC<Props> = ({ message }) => {
  return (
    <VegaCard padding="size-24" variant="border">
      <VegaFlex direction="col" gap="size-8">
          <VegaFont as="h3" variant="font-h6">
            <b>Origin: </b>
            {message.origin}
          </VegaFont>
          <VegaFont as="h3" variant="font-h6">
            <b>Event: </b>
            {message.data.event}
          </VegaFont>
          <VegaDivider />
          <VegaFont as="p" variant="font-p1-short">
            <b>Full Event Payload:</b>
          </VegaFont>
          <pre>{JSON.stringify(message.data, null, 2)}</pre>
      </VegaFlex>
    </VegaCard>
  );
};

export default ReceivedMessage;
